import React from 'react';
import { useStore } from 'react-redux';
import { noop } from 'lodash';
import { Point } from '@printu/geom';
import { getViewportDesignToVirtual } from '@printu/viewport';
import { ProjectActions } from 'app/stores/project/actions';
import { getSelectedMarkers } from 'app/stores/selectors';
const Consts = {
    largeStep: 10,
};
// Position deltas for keyboard
const KeyPositionDeltas = {
    ArrowLeft: { x: -1, y: 0 },
    ArrowUp: { x: 0, y: -1 },
    ArrowRight: { x: 1, y: 0 },
    ArrowDown: { x: 0, y: 1 },
};
export const useKeyMove = (params) => {
    const { active } = params;
    const store = useStore();
    const { dispatch, getState } = store;
    const onKeyDown = React.useCallback((evt) => {
        const delta = KeyPositionDeltas[evt.key];
        if (!delta) {
            return;
        }
        const state = getState();
        const markers = getSelectedMarkers(state);
        if (!markers || !markers.length) {
            return;
        }
        const { viewport } = state;
        const designDelta = new Point(delta).multiply(evt.shiftKey
            ? configGet('key_move_large_step', Consts.largeStep)
            : 1);
        const virtualDelta = getViewportDesignToVirtual(viewport, designDelta);
        dispatch(ProjectActions.itemsUpdate({
            patches: markers.reduce((patch, marker) => {
                patch[marker.id] = {
                    x: marker.x + virtualDelta.x,
                    y: marker.y + virtualDelta.y,
                };
                return patch;
            }, {}),
        }));
    }, [getState, dispatch]);
    // -----------------------
    // Add keyboard handlers
    // -----------------------
    React.useEffect(() => {
        if (!active) {
            return noop;
        }
        document.addEventListener('keydown', onKeyDown, true);
        return () => {
            document.removeEventListener('keydown', onKeyDown, true);
        };
    }, [active, onKeyDown]);
};
